// extracted by mini-css-extract-plugin
module.exports = {"table":"Statistics_table__3LCQa","average":"Statistics_average__33Kfx","progress":"Statistics_progress__rTNZU"};